// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-map{height:100%;min-height:0}@media(max-width:640px){.vue-map-container.locations-map{height:400px!important;min-height:400px!important}}", ""]);
// Exports
module.exports = exports;
